module.exports = "<product-filter-form ng-if=$ctrl.isDesktop> </product-filter-form> <div class=home__image> <img src=\"/assets/img/home--desktop.jpg?cb=2026-09-02\"> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.template.html
// module id = 543
// module chunks = 0